import { apiRequest } from "@/services/api-client";
import { MovePokemonsInput, MovePokemonsOutput } from "types/web-app";

export const movePokemons = (input: MovePokemonsInput) =>
  apiRequest<MovePokemonsOutput>("/box/move", {
    method: "POST",
    body: JSON.stringify(input),
  });
